import { memo } from 'react';
import { useFormikContext } from 'formik';
import { StatementsFormVM } from 'front-office/view-models/statements/statements-form';
import { Grid } from '@mui/material';
import PmiTextField from 'shell/components/shared/text-field';

const GenericDeclarationComponent = (): React.ReactElement => {
  const formContext = useFormikContext<StatementsFormVM>();

  return (
    <Grid item container spacing={2}>
      <Grid item xs={12}>
        <PmiTextField
          label="Dichiarazione"
          aria-label="Dichiarazione"
          id="declaration"
          fullWidth
          multiline
          inputProps={{
            spellCheck: true,
            lang: 'it',
          }}
          rows={5}
          value={formContext.values?.declaration || ''}
          onChange={(event) => {
            formContext.setFieldValue('declaration', event.target.value);
          }}
        />
      </Grid>
    </Grid>
  );
};

GenericDeclarationComponent.displayName = 'Generic Declaration component';

const GenericDeclaration = memo(GenericDeclarationComponent);

export default GenericDeclaration;
